import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomHistoryVisibilityMessageProps {
  message: IMatrixMessage;
  className?: string;
}

const visibilityMap: Record<string, string> = {
  shared: '所有成员可见',
  invited: '仅被邀请成员可见',
  joined: '仅加入后可见',
  world_readable: '所有人可见',
};

export const RoomHistoryVisibilityMessage = ({ message, className = '' }: RoomHistoryVisibilityMessageProps) => {
  const sender = message.sender;
  const visibility = message.content.history_visibility;
  const text = visibilityMap[visibility] || visibility;
  return (
    <div className={`room-history-visibility-message ${className}`} style={{ color: '#8e24aa', padding: '8px 0' }}>
      {sender ? `${sender} 修改了房间历史可见性为「${text}」` : `房间历史可见性被修改为「${text}」`}
    </div>
  );
}; 